<template>
  <div flex gap-4 font-mono>
    <Button :disabled="!date" :color="color" text-sm @click="clickPreviousDay">
      <div class="i-material-symbols-arrow-back-rounded inline-block"></div>
    </Button>
    <input type="date" v-model="date" :max="today" bg-stone-50 p-1 rounded class="min-w-[8.5rem]" />
    <Button :disabled="!date || today == date" :color="color" text-sm @click="clickNextDay">
      <div class="i-material-symbols-arrow-forward-rounded inline-block"></div>
    </Button>
  </div>
</template>
<script setup>
import { useVModel } from "@vueuse/core";

const props = defineProps({
  modelValue: {
    type: String,
  },
  color: {
    type: String,
    default: "stone",
  },
});

const emit = defineEmits(["update:modelValue"]);

const date = useVModel(props, "modelValue", emit);

const previousDay = computed(() => {
  const day = date.value ? new Date(`${date.value}T00:00:00Z`) : new Date();
  day.setDate(day.getDate() - 1);
  return day;
});

const today = toISODate(new Date());

const nextDay = computed(() => {
  const day = date.value ? new Date(`${date.value}T00:00:00Z`) : new Date();
  day.setDate(day.getDate() + 1);
  return day;
});

function clickPreviousDay() {
  date.value = toISODate(previousDay.value);
}
function clickNextDay() {
  date.value = toISODate(nextDay.value);
}
</script>
